import React from 'react';
import PropTypes from "prop-types";
import { Surveys } from 'utils/types';
import css from "./Confirmation.css";
import Modal from 'react-modal';
import { Button } from "semantic-ui-react";
import { SFSurveysTenantLanguage } from "utils/types";

export default class Confirmation extends React.Component {

  constructor() {
    super();
    Modal.setAppElement(document.getElementById('main-center'));
    this.closeButtonRef = React.createRef();
  }

  get confirmationMessage() {
    return `You have successfully submitted ${this.selectedSurvey.surveyName}.`;
  }

  get noMoreSurvey() {
    if ( this.hasNextSurvey ) return null;
    return <div className={css['confirmation-text']}>{`You have no more ${this.props.progressSurveyWords.plural.surveys} to complete.`}</div>;
  }

  get hasNextSurvey() {
    return this.props.surveys.length > 1;
  }

  get selectedSurvey() {
    return this.props.surveys.find(e => e.surveyId === this.props.surveyId);
  }

  render() {
    if ( !this.selectedSurvey ) return null;
    return (
      <Modal
        isOpen={this.props.isOpen}
        onAfterOpen={() => this.closeButtonRef.current.focus()}
        onRequestClose={this.props.onClose}
        overlayClassName={css['overlay']}
        className={css['modal']}>
        <div className={css['container']}>
          <img 
            src="../images/starfish/Happy_starfish.png" 
            aria-hidden="true" 
            className={css['image']}
          />
          <div className={css['thank-you']}>Thank you!</div>
          <div className={css['confirmation-text']}>{this.confirmationMessage}</div>
          {this.noMoreSurvey}
          <Button 
            className={css['close-button']} 
            onClick={this.props.onClose} 
            ref={this.closeButtonRef}>
            {this.hasNextSurvey ? `NEXT ${this.props.progressSurveyWords.singular.survey.toUpperCase()}` : "OKAY"}
          </Button>
        </div>
      </Modal>
    );
  }
}

Confirmation.propTypes = {
  surveys: Surveys.isRequired,
  surveyId: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  progressSurveyWords: SFSurveysTenantLanguage
};
